<studio-icon class="notification-icon" [name]="data.type"></studio-icon>
<div class="content">
  <div class="title">{{ data.title }}</div>
  <div *ngIf="data.description" class="description">{{ data.description }}</div>
</div>
<studio-icon class="dismissButton" name="close" size="18" (click)="dismiss()"></studio-icon>
